import SvgIcon from "@mui/material/SvgIcon";

interface FieldsIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function FieldsIcon({
  htmlColor,
  fontSize = "medium",
}: FieldsIconProps) {
  return (
    <SvgIcon viewBox="0 0 14 14" fontSize={fontSize}>
      <path
        d="M6.2125 11.1475V2.8525C6.2125 2.065 5.88 1.75 5.04 1.75H2.9225C2.0825 1.75 1.75 2.065 1.75 2.8525V11.1475C1.75 11.935 2.0825 12.25 2.9225 12.25H5.04C5.88 12.25 6.2125 11.935 6.2125 11.1475Z"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="1.75"
        y1="7.14667"
        x2="6.41667"
        y2="7.14667"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
      />
      <line
        x1="7.58398"
        y1="7.14667"
        x2="12.2507"
        y2="7.14667"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
      />
      <path
        d="M12.2496 11.1475V7.29167V2.8525C12.2496 2.065 11.9171 1.75 11.0771 1.75H8.95961C8.12544 1.75 7.78711 2.065 7.78711 2.8525V11.1475C7.78711 11.935 8.11961 12.25 8.95961 12.25H11.0771C11.9171 12.25 12.2496 11.935 12.2496 11.1475Z"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
